/**
 * Accès au domaine trackers.
 *
 * Pas de `staleTime` long comme pour les géozones : l'affectation d'un tracker peut changer à tout
 * moment côté référentiel `correspondance_tracker`, et la télémétrie évolue à chaque cycle
 * d'ingestion (jusqu'à 12h d'écart, `docs/DECISIONS.md` D65) — l'écran doit refléter l'état le plus
 * frais disponible, pas une valeur mise en cache pour longtemps.
 */
import { useQuery } from "@tanstack/react-query";

import { api } from "../../shared/api/client";
import type { Tracker } from "../../shared/api/types";

export function useTrackers({ actif = true }: { actif?: boolean } = {}) {
  return useQuery({
    enabled: actif,
    queryKey: ["trackers"],
    queryFn: () => api.lire<Tracker[]>("/v1/trackers"),
  });
}
